export const MapFoldIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '19'}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.58333 14.0833L0.75 17.4167V4.08333L6.58333 0.75M6.58333 14.0833L13.25 17.4167M6.58333 14.0833V0.75M13.25 17.4167L19.0833 14.0833V0.75L13.25 4.08333M13.25 17.4167V4.08333M13.25 4.08333L6.58333 0.75"
      stroke={props?.color || 'white'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
